import { defaultFilter } from './filterReducer'
import { todayIso }      from '@helpers/javascript/date_helpers'
import { MANAGER }       from '@helpers/javascript/config/CONSTANTS'
// Toggle Filter Icon
export const changeFilterStatusAction = newStatus => dispatch => dispatch({
  type: FILTERS.CHANGE_STATUS,
  payload: {
    status: newStatus,
    search: ''
  }
})

// Reactive Toggle
export const toggleReactiveAction = old_type => dispatch => dispatch({
  type: FILTERS.TOGGLE_REACTIVE,
  payload: {
    workorder_type: { Reactive: !old_type },
    search: ''
  }
})

// Preventive Toggle
export const togglePreventiveAction = old_type => dispatch => dispatch({
  type: FILTERS.TOGGLE_PREVENTIVE,
  payload: {
    workorder_type: { Preventive: !old_type },
    search: ''
  }
})

// Installation Toggle
export const toggleInstallationAction = old_type => dispatch => dispatch({
  type: FILTERS.TOGGLE_INSTALLATION,
  payload: {
    workorder_type: { Installation: !old_type },
    search: ''
  }
})

// Open distance filters toggle
export const toggleByDistanceAction = location => dispatch => dispatch({
  type: FILTERS.BY_DISTANCE,
  payload: { location }
})

// Technician select
export const selectTechnicianAction = technician => dispatch => dispatch({
  type: FILTERS.SELECT_TECHNICIAN,
  payload: { technician }
})

// Category select
export const selectCategoryAction = category => dispatch => dispatch({
  type: FILTERS.SELECT_CATEGORY,
  payload: { category }
})

// Date Selection action
export const changeDateAction = newDateDiff => dispatch => dispatch({
  type: FILTERS.CHANGE_DATE,
  payload: {
    date: newDateDiff,
    search: ''
  }
})

// Search action
export const searchWorkordersAction = search => dispatch => dispatch({
  type: FILTERS.SEARCH_WORKORDERS,
  payload: {
    search: search,
    status: ''
  }
})

// Filter field action
export const changeFieldsAction = fields => dispatch => dispatch({
  type: FILTERS.CHANGE_FIELDS,
  payload: { fields }
})

const ownTechnician = user =>
  user?.id && user.type === MANAGER && user.manager_as_technician ? user.id : null

// Reset action
// keepDay: the list and the map share their day and technician.
// Otherwise the technician goes back to the user's own, as on opening the app.
export const resetFiltersAction = ({ keepDay = false } = {}) => (dispatch, getState) => {
  dispatch({ type: FILTERS.RESET, payload: { keepDay, technician: ownTechnician(getState().user) } })
}

// Once per app load, so a pick made since, "all" included, survives the next view's mount.
let technicianAutoselected = false
export const autoselectTechnicianAction = user => (dispatch, getState) => {
  if (technicianAutoselected || !user?.id) return
  technicianAutoselected = true
  const technician = ownTechnician(user)
  if (!technician) return
  if (getState().filters.technician) return
  dispatch(selectTechnicianAction(technician))
}

export const nextPageAction = () => dispatch => {
  dispatch({ type: FILTERS.NEXT_PAGE })
}

export const resetPageAction = () => dispatch => {
  dispatch({ type: FILTERS.RESET_PAGE })
}

// Instantiate actions names
export const FILTERS = {
  TOGGLE_FILTERS:      'TOGGLE_FILTERS',
  CHANGE_STATUS:       'CHANGE_STATUS',
  NEXT_PAGE:           'NEXT_PAGE',
  RESET_PAGE:          'RESET_PAGE',
  TOGGLE_REACTIVE:     'TOGGLE_REACTIVE',
  TOGGLE_PREVENTIVE:   'TOGGLE_PREVENTIVE',
  TOGGLE_INSTALLATION: 'TOGGLE_INSTALLATION',
  BY_DISTANCE:         'BY_DISTANCE',
  SELECT_TECHNICIAN:   'SELECT_TECHNICIAN',
  SELECT_CATEGORY:     'SELECT_CATEGORY',
  CHANGE_DATE:         'CHANGE_DATE',
  SEARCH_WORKORDERS:   'SEARCH_WORKORDERS',
  CHANGE_FIELDS:       'CHANGE_FIELDS',
  RESET:               'RESET_FILTERS',

  toggleFiltersResponse:    ({ state, rotate, show_filters })         => ({ ...state, rotate, show_filters}),
  nextPageResponse:         ({ state })                               => ({ ...state, page: state.page + 1 }),
  resetPageResponse:        ({ state })                               => ({ ...state, page: 1 }),
  changeStatusResponse:     ({ state, status, search })               => ({ ...state, status, search, date: todayIso(), page: 1 }),
  toggleTypeResponse:       ({ state, workorder_type, search })       => ({ ...state, workorder_type, search, page: 1 }),
  byDistanceResponse:       ({ state, by_distance, })                 => ({ ...state, by_distance, page: 1 }),
  selectTechnicianResponse: ({ state, technician, })                  => ({ ...state, technician, page: 1 }),
  selectCategoryResponse:   ({ state, category, })                    => ({ ...state, category, page: 1 }),
  changeDateResponse:       ({ state, date, search, })                => ({ ...state, date, search, page: 1 }),
  searchWorkordersResponse: ({ state, search })                       => ({ ...state, search, page: 1 }),
  changeFieldsResponse:     ({ state, fields })                       => ({ ...state, fields, page: 1 }),
  resetFiltersResponse:     ({ state, keepDay, technician })          => keepDay
    ? { ...defaultFilter, date: state.date, technician: state.technician }
    : { ...defaultFilter, date: todayIso(), technician: technician ?? defaultFilter.technician }
}
